import { render, staticRenderFns } from "./marketFunds.vue?vue&type=template&id=efc95688&scoped=true&"
import script from "./marketFunds.vue?vue&type=script&lang=js&"
export * from "./marketFunds.vue?vue&type=script&lang=js&"
import style0 from "./marketFunds.vue?vue&type=style&index=0&id=efc95688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc95688",
  null
  
)

export default component.exports